import type { SyntheticEvent } from 'react';

export const FALLBACK_IMAGE = '/project-placeholder.svg';

export const handleImageError = (event: SyntheticEvent<HTMLImageElement>) => {
    const image = event.currentTarget;

    if (image.getAttribute('src') === FALLBACK_IMAGE) {
        return;
    }

    image.onerror = null;
    image.src = FALLBACK_IMAGE;
};
